import { IonCard } from '@ionic/react';
import styled from 'styled-components';
import { AllieDefaultColors } from '../../common/color.types';
import { AllieCardProps } from './Card.types';

const backgroundVars = {
  light: 'light-main',
  transparent: 'transparent',
  neutral: 'neutral-50',
  primary: 'primary-50',
  secondary: 'secondary-50',
  tertiary: 'tertiary-50',
  success: 'success-main',
  warning: 'warning-main',
  error: 'error-main',
};

const defaults: Record<string, AllieDefaultColors> = {
  backgroundColor: 'light',
};

export const StyledCard: any = styled(IonCard)<AllieCardProps>`
  --background: ${(props: AllieCardProps) =>
    `var(--allie-color-${backgroundVars[props.backgroundColor || defaults.backgroundColor]})`};
  --color: ${(props: AllieCardProps) => `var(--allie-color-${props.allieColor})`};
  border-radius: ${(props: AllieCardProps) =>
    `var(--allie-radius-${props.radius})` || 'var(--allie-radius-xs)'};
`;
